export default __webpack_public_path__ + "static/logo-sala-pro-3a6272c4ffeef8b89dae9ac9a88b54f5.svg";